<template>
  <div >
    <van-nav-bar
      title="订阅设备"
      left-text="返回"
      left-arrow
      right-text="完成"
      @click-left="$router.go(-1)"
      @click-right="chooseFinished"
      :fixed="true"
    />
    <div class="body">
      <!-- {{childGroup}} -->
      <van-checkbox-group v-model="result">
        <van-cell-group>
          <van-cell  v-for="group in childGroup" :key="group.Id">
            <template slot="title">
              <div v-show="group.children" @click="chooseGroup(group)" class="van-cell-text" style="display: inline-block;width: 80%">{{group.Name}}</div>
              <div v-show="!group.children" class="van-cell-text" style="display: inline-block;width: 80%">{{group.Name}}</div>
              <van-checkbox style="float: right;" :name="group.Id"></van-checkbox>
            </template>
            
          </van-cell>
        </van-cell-group>
      </van-checkbox-group>
      <!-- <button @click="backLastGroup">click</button> -->
    </div>
    
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { ImagePreview,Dialog,Toast  } from 'vant';

export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      result:[],
      groupInfo:'',
      childGroup:'',
      lastGroup:'',
      parent: 32
    }
  },
  computed:{
    ...mapState(['stations', 'userInfo'])
  },
  mounted(){
    if(this.userInfo){
      this.getGroupInfo()  
    }
  },
  watch:{
    userInfo(){
      this.getGroupInfo()
    },
    '$route'(to,from){
      var p = to.params.parent
      console.log(to)
      if(p){
        this.parent = p  
      }else{
        this.parent = this.groupInfo[0].Id
      }
    },
    parent(){
      this.getChildByParent(this.groupInfo)
    }
  },
  methods:{
    RndNum(n){
      var rnd="";
      for(var i=0;i<n;i++)
          rnd+=Math.floor(Math.random()*10);
      return rnd;
    },
    GetQueryString:function(name){
      var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if(r!=null)return  unescape(r[2]); return null;
    },
    getGroupInfo(){
      var self = this
      axios.get('/api/wz_api_py/group_merge/v1/get_user_gdevice_tree?groups='+this.userInfo.StationGroupIds).then(function(resp){
        self.groupInfo = resp.data
        self.parentGroup = self.groupInfo
        self.parent = self.groupInfo[0].Id
        self.getChildByParent(self.groupInfo)
      })
    },
    chooseFinished(){
      var self = this
      this.axios_base.get('session/subscribeStations?stations='+this.result).then(function(resp){
        console.log(resp)
        self.$router.push({name:'mySubscribeSns'})
      })
    },
    chooseGroup(group){
      var parent = group.Id
      this.$router.push({name:'subscribe',params:{parent:parent}})
    },
    getChildByParent(groupInfo){
      for(var i in groupInfo){
        if(groupInfo[i].Id == this.parent){
          this.childGroup = groupInfo[i].children
          break
          return 
        }
      }
      for(var i in groupInfo){
        this.getChildByParent(groupInfo[i].children)
      }
      
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/application/subscribe/subscribe.vue